import { Form, useForm } from '@/components/forms';
import Input from '@/components/forms/Input';
import Select from '@/components/forms/Select';
import Textarea from '@/components/forms/Textarea';
import { Upload } from '@/components/upload';
import { FileWithPreview } from '@/hooks/use-file-upload';
import { imageFileSchema } from '@/lib/uploadSchema';
import { z } from 'zod';

const advertiseManagementSchema = z.object({
  title: z.string().min(2, { message: 'Title must be at least 2 characters.' }),
  link: z.string().min(2, { message: 'Link must be at least 2 characters.' }),

  description: z.string().min(1, { message: 'Description is required' }),
  fruit: z.union([z.literal('apple'), z.literal('orange')]),
  image: imageFileSchema,
});

export const AdvertiseManagement = () => {
  const form = useForm({ schema: advertiseManagementSchema, mode: 'onBlur' });

  const FruitMap: Record<z.infer<typeof advertiseManagementSchema>['fruit'], string> = {
    apple: 'Apple',
    orange: 'Orange',
  };

  const fruitOptions = Object.entries(FruitMap).map(([value, label]) => ({
    value,
    label,
  }));

  const handleFilesChange = (files: FileWithPreview[]) => {
    if (files[0]?.file instanceof File) {
      form.setValue('image', files[0].file);
    } else {
      form.setValue('image', new File([], ''));
    }
  };
  return (
    <Form
      form={form}
      onSubmit={() => {
        return new Promise((res) => {
          setTimeout(res, 5000);
        });
      }}
    >
      <div className="w-full flex flex-col gap-4.5">
        <Input label="adManagement.page.ads.form.title" {...form.register('title')} />
        <Textarea label="adManagement.page.ads.form.description" {...form.register('description')} />
        <Upload
          label="adManagement.page.ads.form.uploadImage"
          onFilesChange={handleFilesChange}
          {...form.register('image')}
          isRequired
        />
        <div className="grid grid-cols-2 gap-4.5">
          <Input label="adManagement.page.ads.form.link" {...form.register('link')} />
          <Select
            label="adManagement.page.ads.form.displayOrder"
            {...form.register('fruit')}
            options={fruitOptions}
            placeholder="Select"
          />
        </div>
      </div>
    </Form>
  );
};
